import React from 'react';
import { useLang } from '../context/LanguageContext';
import { t } from '../translations';

const ProjectCard = ({ title, description, tech, link }) => (
  <div className="p-4 bg-white rounded-md border border-zinc-200 hover:border-zinc-400 transition flex flex-col h-full">
    <h3 className="text-base font-semibold text-zinc-900 mb-1.5 leading-tight">
      <a href={link} target="_blank" rel="noreferrer" className="hover:underline underline-offset-2">
        {title}
      </a>
    </h3>
    <p className="text-sm text-zinc-600 mb-3 flex-grow leading-relaxed">{description}</p>
    <p className="mono text-xs text-zinc-500">{tech.join(' / ')}</p>
  </div>
);

const Projects = () => {
  const { lang } = useLang();
  const tx = t[lang];

  return (
    <>
      <section className="mt-6 bg-white border border-zinc-200 rounded-lg p-6 md:p-8">
        <h2 className="text-lg font-bold text-zinc-900 mb-1">{tx.ownProductsTitle}</h2>
        <p className="text-sm text-zinc-500 mb-5">{tx.ownProductsSubtitle}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {tx.ownProducts.map((p) => <ProjectCard key={p.title} {...p} />)}
        </div>
      </section>

      <section className="mt-6 bg-white border border-zinc-200 rounded-lg p-6 md:p-8">
        <h2 className="text-lg font-bold text-zinc-900 mb-1">{tx.clientProjectsTitle}</h2>
        <p className="text-sm text-zinc-500 mb-5">{tx.clientProjectsSubtitle}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {tx.clientProjects.map((p) => <ProjectCard key={p.title} {...p} />)}
        </div>
      </section>
    </>
  );
};

export default Projects;
